@if (areThereAnyDownloads) {
<div class="details-card-wrapper">

  <div class="details-card">
    <div class="details-card-body">
      <div class="row">
        @for (user_manual of user_manuals; track user_manual) {
          @if (user_manual?.link) {
          <base-document-button
            class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-20 pb-20 ps-0"
            label="User Manual"
            [type]="DownloadType.USER_MANUALS"
            [href]="user_manual?.link || ''"
          ></base-document-button>
          }
        }

        @for (catalog of catalogs; track catalog) {
          @if (catalog?.link) {
          <base-document-button
            class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-20 pb-20 ps-0"
            label="Catalog"
            [type]="DownloadType.CATALOG"
            [href]="catalog?.link || ''"
          ></base-document-button>
          }
        }

        @for (howToGuide of howToGuides; track howToGuide) {
          @if (howToGuide?.link) {
          <base-document-button
            class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-20 pb-20 ps-0"
            label="How To Guide"
            [type]="DownloadType.HOW_TO_GUIDE"
            [href]="howToGuide?.link || ''"
          ></base-document-button>
          }
        }

        @for (price_list of price_lists; track price_list) {
          @if (price_list?.link) {
          <base-document-button
            class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-20 pb-20 ps-0"
            label="Price List"
            [type]="DownloadType.PRICE_LIST"
            [href]="price_list?.link || ''"
          ></base-document-button>
          }
        }
      </div>
    </div>
  </div>
</div>
}
